<template>
  <div class="feedback-form-container">
    <div v-if="formSended">
      <div class="font-weight-bold">Підтвердження</div>
      <div class="mt-3">
        Дякуємо, заява надіслана. Найближчим часом наші спеціалісти зв’яжуться з
        Вами.
      </div>
      <div class="text-center mt-4">
        <v-btn
          color="#549EC7"
          tile
          class="submit-form-button elevation-0 mt-2"
          @click="resetForm()"
          >Зрозуміло</v-btn
        >
      </div>
    </div>
    <v-form v-else ref="form" @submit.prevent="submit" v-model="formValidation">
      <div class="font-weight-bold mb-4">Форма зворотнього зв’язку</div>
      <div class="input-block">
        <label class="input-label"
          >Назва компанії <span class="require">*</span></label
        >
        <v-text-field
          :rules="required"
          dense
          outlined
          v-model="feedbackForm.organizationName"
        />
      </div>
      <div class="input-block">
        <label class="input-label">Ім'я <span class="require">*</span></label>
        <v-text-field
          :rules="required"
          dense
          outlined
          v-model="feedbackForm.fullName"
        />
      </div>
      <v-row>
        <v-col class="input-block"
          ><label class="input-label"
            >Продукт АСКОД <span class="require">*</span></label
          >
          <v-select
            :items="products"
            item-text="name"
            item-value="name"
            dense
            :rules="required"
            outlined
            v-model="feedbackForm.product"
        /></v-col>
        <v-col class="input-block"
          ><label class="input-label">Версія продукту</label>
          <v-text-field dense outlined v-model="feedbackForm.productVersion"
        /></v-col>
      </v-row>
      <div class="input-block">
        <label class="input-label">Операційна система</label>
        <v-select
          dense
          :items="osList"
          item-value="name"
          item-text="name"
          outlined
          v-model="feedbackForm.os"
        />
      </div>
      <div class="input-block">
        <label class="input-label">Телефон </label>
        <v-text-field
          dense
          outlined
          v-model="feedbackForm.phone"
          v-mask="'###-###-##-##'"
          prefix="+38"
        />
      </div>
      <div class="input-block">
        <label class="input-label">E-mail <span class="require">*</span></label>
        <v-text-field
          dense
          outlined
          v-model="feedbackForm.email"
          :rules="email"
        />
      </div>
      <div class="input-block">
        <label class="input-label"
          >Зміст запитання <span class="require">*</span></label
        >
        <v-textarea
          :rules="required"
          dense
          outlined
          v-model="feedbackForm.question"
        />
      </div>
      <div>
        <VueFileAgent
          helpText="Додати файл"
          :multiple="true"
          ref="fileAgent"
          theme="list"
          @beforedelete="onBeforeDelete"
          :maxSize="'5MB'"
          :deletable="true"
          :errorText="{
            type: 'Please select images, videos, pdf or zip files',
            size: 'Файл повинен бути менше ніж 5МБ'
          }"
          accept=".doc, .pdf, .docx, .xls., .xlsx"
          v-model="files"
        />
      </div>
      <app-captcha
        ref="recaptcha"
        :isBudgeHidden="false"
        @verify="sendForm($event)"
      />
      <div class="d-flex align-center justify-space-around mt-3">
        <v-btn
          :loading="loading"
          tile
          class="submit-form-button"
          type="submit"
          elevation="0"
          color="#549EC7"
          >Відправити</v-btn
        >
      </div>
    </v-form>
  </div>
</template>
<script>
import serviceDataAccess from '../../../services/service.data-access'
// import VueRecaptcha from 'vue-recaptcha'
import { required, email, phone } from '../../../utils/validation-rules'
import { keys } from 'lodash'
import AppCaptcha from '../../_shared/AppCaptcha.vue'

const oprationSystems = [
  { name: 'Windows' },
  { name: 'macOS' },
  { name: 'Linux' },
  { name: 'iOS' },
  { name: 'Android' },
  { name: 'Chrome OS' },
  { name: 'Інша' }
]

const products = [
  {
    name: 'АСКОД Корпоративний/Web',
    type: 'Askod'
  },
  { name: 'АРМ Керівника', type: 'Arm' },
  { name: 'АСКОД Онлайн', type: 'AskodOnline' },
  { name: 'АСКОД Чат', type: 'Chat' },
  { name: 'АСКОД Реєстр', type: 'Reestr' },
  {
    name: 'Електронна черга',
    type: 'Queue'
  },
  {
    name: 'Архів',
    type: 'Archive'
  },
  {
    name: 'Послуги',
    type: 'Service'
  },
  { name: 'Портал', type: 'Portal' },
  { name: 'Засідання', type: 'Meeting' },
  { name: 'Конструктор', type: 'Конструктор' },
  {
    name: 'Адміністрування',
    type: 'Admin'
  },
  {
    name: 'Інше',
    type: 'Other'
  }
]

// todo: add recaptcha
export default {
  name: 'FeedbackForm',
  components: {
    // VueRecaptcha,
    AppCaptcha
  },
  data: () => ({
    formValidation: false,
    feedbackForm: {
      organizationName: '',
      fullName: '',
      product: '',
      productVersion: '',
      os: '',
      phone: '',
      email: '',
      question: ''
    },
    loading: false,
    files: [],
    formSended: false
  }),
  computed: {
    required: () => [required],
    phone: () => [required, phone],
    email: () => [required, email],
    products: () => products,
    osList: () => oprationSystems,
    uploadUrl: function () {
      return `${this.$store.getters.getApiBasePath}/file/upload`
    }
  },
  methods: {
    onBeforeDelete(fileRecord) {
      this.$refs.fileAgent.deleteFileRecord(fileRecord)
    },
    resetForm() {
      this.feedbackForm = {}
      this.formSended = false
      this.files = []
      this.$refs.googleReacptcha.reset()
    },
    submit() {
      this.$refs.recaptcha.execute()
    },
    async sendForm(response) {
      const isValid = await this.$refs.form.validate()
      var hasNotValidFile = this.$refs.fileAgent.fileRecords.some((e) =>
        Object.values(e.error).includes(true)
      )

      try {
        if (isValid && !hasNotValidFile) {
          var formData = new FormData()

          if (this.files) {
            this.files.forEach((file) => {
              formData.append('files', new File([file.file], file.name()))
            })
          }
          const formKeys = keys(this.feedbackForm)
          formKeys.forEach((key) => {
            formData.append(key, this.feedbackForm[key])
          })
          formData.append('googleReCaptchaResponse', response)

          this.loading = true
          await serviceDataAccess.sendSupportEmail(formData)
          this.$uiService.success('Форма відправлена успішно')
          this.formSended = true
        }
      } catch (e) {
        this.$uiService.error('Помилка відправки форми')
      } finally {
        this.loading = false
      }
      console.log('Verify: ' + response)
    },
    onCaptchaExpired() {
      this.console('Captcha expired')
      this.$refs.googleReacptcha.reset()
    }
  }
}
</script>
<style lang="scss">
.feedback-form-container {
  font-size: 1.7rem;

  .input-block .v-input {
    margin-top: 0.2rem;
  }
  .require {
    color: red;
  }
}
.v-list-item__title {
  font-size: 1.6rem !important;
  line-height: 1.7rem !important;
}

.grecaptcha-badge {
  z-index: 1;
}
</style>
